import React from "react";
import styled from 'styled-components';
import NoContentForFullScreen from '../../../common/NoContentForFullScreen'
import LibraryCard from '../find/LibraryCard'
import LibraryResponse from '../near/LibraryNearResponse'

interface Props {
    libraries: LibraryResponse[]
}

const LibraryRegionListCard: React.FC<Props> = ({libraries}) => {
    return (
        <div className="row">
            {libraries.length === 0 ? (
                <NoContentForFullScreen message="이 지역에는 도서관이 없어요"/>
            ) : (
                <Row>
                    {libraries.map(library => {
                        return (
                            <Col>
                                <LibraryCard library={library}/>
                            </Col>
                        )
                    })}
                </Row>
            )}
        </div>
    )
}

const Row = styled.div.attrs({
    className: 'row'
})`
    width: 100%;
    margin: 0;
    padding: 0;
`;

const Col = styled.div.attrs({
    className: 'col-12 col-md-6'
})`
`;

export default LibraryRegionListCard